import { render, staticRenderFns } from "./VipContent.vue?vue&type=template&id=4ed67ff5&scoped=true&"
import script from "./VipContent.vue?vue&type=script&lang=ts&"
export * from "./VipContent.vue?vue&type=script&lang=ts&"
import style0 from "./VipContent.vue?vue&type=style&index=0&id=4ed67ff5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed67ff5",
  null
  
)

export default component.exports